import {
  booleanAttribute,
  Component,
  ContentChild,
  ElementRef,
  HostBinding,
  Input,
} from '@angular/core';
import { FormControlName, Validators } from '@angular/forms';
import { InputDirective } from '@shared/directives/input.directive';

@Component({
  selector: 'sigecom-input-container',
  template: `
    <div
      class="rounded-md px-2 transition duration-300 ease-in-out relative"
      [ngClass]="{
        class,
        'py-2' : !smallInput,
        'border border-solid': showBorder,
        'bg-gray-300': isDropdown,
        'border-sigecom-danger': errorMessage,
        'border-sigecom-gray':
          !errorMessage &&
          !((isRequired || inputRequired) && enableRequiredBorder),
        'opacity-40 pointer-events-none': isDisabled || inputDisabled,
        'border-sigecom-info ring-1 ring-blue-500':
          !errorMessage &&
          (isRequired || inputRequired) && enableRequiredBorder,
      }"
    >
      <ng-container *ngIf="label">
        <span
          class="font-bold text-sm py-0 px-2"
          [ngClass]="{
            'text-sigecom-danger': errorMessage,
            'text-sigecom-gray': !errorMessage,
          }"
        >
          {{ label }}
          <span class="text-sigecom-danger">
            {{ isRequired || inputRequired ? '*' : '' }}
          </span>
        </span>
      </ng-container>

      <!-- <div #contentWrapper> -->
      <ng-content></ng-content>
      <div class="absolute right-1 bottom-1">
        <ng-container *ngIf="!isLoading; else loadingTemplate"> </ng-container>
        <ng-template #loadingTemplate>
          <sigecom-circle-loading class="pr-3" [sizeInRem]="1.2" color="blue" />
        </ng-template>
      </div>
    </div>

    <sigecom-error class="w-full text-start" *ngIf="errorMessage" [error]="errorMessage" [disabled]="isDisabled" />
    <!-- <div *ngIf="errorMessage" class="text-sigecom-danger text-sm">
      <small class=" w-full text-start">{{ errorMessage }}</small>
    </div> -->
  `,
})
// TODO: ADICIONAR VARIANTE COM CAIXA DE BUSCA E EMITIDOR DE EVENTOS.
export class InputContainerComponent {
  // @ViewChild('contentWrapper') content?: ElementRef;
  @HostBinding('class') hostClasses = '';
  @ContentChild(InputDirective, { static: false, read: ElementRef })
  inputElement?: ElementRef;
  @ContentChild(FormControlName) controlName?: FormControlName;
  @Input({transform: booleanAttribute}) smallInput = false
  @Input() label?: string;
  @Input() type: InputTypeEnum = InputTypeEnum.INPUT;
  @Input({ transform: booleanAttribute }) enableRequiredBorder: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() errorMessage?: string;
  @Input() class?: string;
  @Input() isDropdown?: boolean;
  @Input() showBorder: boolean = true;

  protected readonly InputTypeEnum = InputTypeEnum;

  get inputDisabled(): boolean {
    return this.inputElement ? this.inputElement.nativeElement.disabled : false;
  }

  get inputRequired(): boolean {
    if (this.controlName?.control?.hasValidator(Validators.required)) {
      return true;
    }
    return this.inputElement ? this.inputElement.nativeElement.required : false;
  }
  @Input()
  set customClass(value: string) {
    this.hostClasses = value;
  }
}

export enum InputTypeEnum {
  INPUT,
  SELECT,
}
